define([
    "jquery",
    "underscore",
    "marionette",
    "forms/support/customer_service_form",
    "behaviors/form_errors_behavior",
    "behaviors/recaptcha_v3_behavior",
    "backbone.syphon"
], function ($, _, Marionette, CSForm, FormErrorsBehavior, ReCaptchaV3Behavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'submitBtn': '#submit_btn',
            'form': '#cs_form',
            'captchaCheckErrorMsg': '.captcha_check_error_msg'
        },

        events: {
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            recaptcha: {
                behaviorClass: ReCaptchaV3Behavior,
                action: '/support/customer_service'
            }
        },

        initialize: function () {
            this.bindUIElements();

            this.form = new CSForm();

            //recaptcha
            this.triggerMethod('init:recaptcha')
        },

        submit: function (e) {
            if (e) e.preventDefault();
            var that = this;
            var formData = Backbone.Syphon.serialize(that);
            this.form.set(formData);
            var errors = this.form.validate();
            // so far, validation without server finished.

            if (_.size(errors) < 1) {
                this.triggerMethod('validate:recaptcha', function (err, token) {
                    that.ui.captchaCheckErrorMsg.text("");
                    if (err) {
                        var recaptchaError = {captcha_code: 'Google recaptcha can\'t get a token'};
                        that.ui.captchaCheckErrorMsg.text(recaptchaError.captcha_code);
                        // that.triggerMethod('show:errors', recaptchaError);
                        return;
                    }
                    that.triggerMethod('set:token', token, that.ui.form);
                    // after successfully passed through the validation,
                    // reset the form data with recaptcha token.
                    formData = Backbone.Syphon.serialize(that);
                    that.form.set(formData);

                    that.form.validateWithServer({
                        type: 'POST',
                        success: function (model, res) {
                            that.ui.form.submit();
                        },
                        error: function (model, error) {
                            that.ui.captchaCheckErrorMsg.text("");
                            if (error.responseJSON.captcha_check) {
                                that.captchaCheck = error.responseJSON.captcha_check;
                                that.ui.captchaCheckErrorMsg.text(that.captchaCheck);
                            }
                            delete error.responseJSON.captcha_check;
                            that.triggerMethod('show:errors', error.responseJSON);
                        }
                    });

                });
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});